import { forwardRef } from 'react';
import ButtonInternal from './button-internal';
var Button = forwardRef(ButtonInternal);
export default Button;
